<template lang="html">
  <div id="left-menu" class="uk-width-1-2@s">
    <h3 class="uk-heading-line uk-text-center"><span>Menu</span></h3>
      <ul class="uk-nav-primary uk-nav-parent-icon" uk-nav>
          <li class="uk-active"><a href="#">Moje wizyty</a></li>
          <li><a href="#">E-rejestracja</a></li>
          <li><a href="#">Moje dane</a></li>
          <li><a href="#">Dokumenty do pobrania</a></li>
          <li><a href="#">Strona kliniki LENS</a></li>
      </ul>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass">

  #left-menu
    padding-right: 20px

</style>



// WEBPACK FOOTER //
// leftmenu.vue?e986333a